import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function TerminiPage() {
  const SITE_URL = __VITE_SITE_URL__;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">Termini e Condizioni</h1>
          <p className="text-foreground-400 text-sm mb-10">Ultimo aggiornamento: Luglio 2026</p>
          <div className="prose prose-sm text-foreground-600 space-y-6">
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">1. Accettazione dei Termini</h2>
              <p>Utilizzando itaobuyspread.lol, accetti i presenti Termini e Condizioni. Se non accetti questi termini, ti invitiamo a non utilizzare il sito.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">2. Utilizzo del Sito</h2>
              <p>Il sito è destinato esclusivamente a fornire informazioni educative su Itaobuy Spreadsheet. Non è consentito utilizzare il sito per attività illegali o non autorizzate. Tutti i contenuti sono protetti da copyright e non possono essere riprodotti senza autorizzazione.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">3. Limitazione di Responsabilità</h2>
              <p>itaobuyspread.lol non sarà ritenuta responsabile per eventuali danni diretti o indiretti derivanti dall&apos;utilizzo del sito o dei link in esso contenuti. L&apos;utente utilizza il sito a proprio rischio.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">4. Modifiche ai Termini</h2>
              <p>Ci riserviamo il diritto di modificare i presenti Termini e Condizioni in qualsiasi momento. Le modifiche saranno efficaci dal momento della pubblicazione sul sito.</p>
            </section>
          </div>
          <Link to="/" className="inline-flex items-center gap-2 mt-10 text-sm text-primary-500 hover:text-primary-600 transition-colors">
            <i className="ri-arrow-left-line"></i> Torna alla Home
          </Link>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Termini e Condizioni — Itaobuy Spreadsheet Italia',
            description: 'Termini e Condizioni di itaobuyspread.lol. Accettazione, utilizzo del sito, limitazione di responsabilità e modifiche ai termini.',
            inLanguage: 'it',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
            },
          }),
        }}
      />
    </div>
  );
}